import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { httpGet, crafterConf } from "@craftercms/classes";
import { composeUrl } from "@craftercms/utils";
import { getLanguage, languagePicker, removeIgnoreItems } from '../../utils';
import ListItem from '../../components/ListItem/ListItem';
import SharePage from '../../components/SharePage/SharePage';
import ArticlePageHolder from './ArticlePageStyles';
import NotFoundPage from "../FourOhFour/NotFoundPage";
import InnerHTML from 'dangerously-set-html-content';
import SEO from '../../components/SEO/SEO';

const ArticlePage = (props) => {
	const [thumbnail, setThumbnail] = useState([]);
	const [content, setContent] = useState([]);
	const [cpacItemList, setCpacItemList] = useState([]);
	const [cpacItemListBottom, setCpacItemListBottom] = useState([]);
	const [tags, setTags] = useState([]);
	const [showThumbnail, setShowThumbnail] = useState("false");
	const [nodata, setNodata] = useState(false);
	const [pageDesc, setPageDesc] = useState();
	const [message, setMessage] = useState();
	const siteURL = window.location.origin;
	const pageURL = window.location.origin + window.location.pathname;
	const pageLang = props.current_lang;
	const pageLocale = pageLang + "_CA";
	const pageTitle = content.title + " | CPAC.ca";
	let activeLanguage = getLanguage();

	useEffect(() => {
		const craftConf = crafterConf.getConfig();
		const serviceUrl = composeUrl(craftConf, process.env.REACT_APP_CONTENT_MODEL_ENDPOINT);

		httpGet(serviceUrl, { url: props.url, crafterSite: craftConf.site }).subscribe((data) => {
			if (data) {
				let fieldNames = [
					"disabled",
					"title_t", "excerpt_html", "content_html", "byLine_t",
					"thumbnailResult.image_s", "thumbnailResult.altImageTxt_s",
					"cpacItemList;title_t", "cpacItemListBottom;title_t",
					"cpacItemList.title_t", "cpacItemList.description_t", "cpacItemList.image_s", "cpacItemList.altImageTxt_s",
					"cpacItemList.url_s", "cpacItemList.category_t", "cpacItemList.categoryURL_s", "cpacItemList;seeAllUrl_s",
					"cpacItemListBottom.title_t", "cpacItemListBottom.description_t", "cpacItemListBottom.image_s", "cpacItemListBottom.altImageTxt_s",
					"cpacItemListBottom.url_s", "cpacItemListBottom.category_t", "cpacItemListBottom.categoryURL_s", "cpacItemListBottom;seeAllUrl_s",
					"tags.name_s", "tags.description_t", "tags.url_t", "metaDescription_t"
				]
				languagePicker(data, fieldNames);
				let dataPage = data.page;
				if (dataPage.display_thumbnail_b === "true") {
					setShowThumbnail("true");
				} else {
					setShowThumbnail("false");
				}
				setThumbnail(dataPage.thumbnailResult.item[0]);
				setContent(dataPage);
				setCpacItemList(dataPage.cpacItemList);
				setCpacItemListBottom(dataPage.cpacItemListBottom);
				setPageDesc(dataPage.metaDescription);

				// Removing dummy record added to force lists of 1 item
				if (data.page.tags && data.page.tags.item && data.page.tags.item.length > 0) {
					data.page.tags.item = removeIgnoreItems(data.page.tags);
					setTags(dataPage.tags.item)
				}
				if (activeLanguage === "en") {
					setMessage("Sorry, this article has no available translation.");
				} else {
					setMessage("Désolé, il n'existe aucune traduction de ce contenu.");
				}
			} else {
				setNodata(true);
			}
		});

	}, [props.url, props.current_lang]);

	useEffect(() => {
		if (window.localStorage) {
			if (!localStorage.getItem('firstLoad')) {
				localStorage['firstLoad'] = true;
				window.location.reload();
			} else {
				localStorage.removeItem('firstLoad');
			}
		}
	}, [activeLanguage]);

	useEffect(() => {
		props.setCurrentLanguage(props.lan);
	}, [props.lan]);

	const renderTags = () => {
		return tags.map((tag, index) => {
			return (
				<a href={tag.url} key={index}>
					<div className="article-tag">
						<img alt="tag icon" className="tag-icon" src="/static-assets/theme/svg/tag.svg" />
						<span itemProp="keywords">{tag.name}</span>
					</div>
				</a>
			)
		})
	}

	if (content.disabled === "true" || nodata) {
		return <NotFoundPage />
	}
	if (!content.content && !content.title) {
		return (
			<>
			<SEO pageDesc={message} pageURL={pageURL} title={message} pageTitle="CPAC.ca" image="" type="article" pageLocale={pageLocale} />
			<ArticlePageHolder>
				<div className="article-bg">
					<div className="article-content">
						<span className="translation-msg"><p>{message}</p></span>
					</div>
				</div>
			</ArticlePageHolder>
			</>
		)
	}

	return (
		<>
			<SEO pageDesc={pageDesc} pageURL={pageURL} title={content.title} pageTitle={pageTitle} image={siteURL + thumbnail.image} type="article" pageLocale={pageLocale} />
			<ArticlePageHolder>
				<div className="row">
					<h1 className="page-title">{content.title}</h1>
				</div>
				<div className="article-bg" itemScope="itemscope" itemType="https://schema.org/NewsArticle">
					<span className="content-title" itemProp="headline">{content.title}</span>
					{showThumbnail && showThumbnail === "true" ?
						<div className="article-hero article-hero-contain">
							<div className="article-hero-image-block">
								<img itemProp='image' src={thumbnail.image} alt={thumbnail.altImageTxt} />
								<meta itemProp='thumbnailUrl' content={siteURL + thumbnail.image} />
							</div>
						</div> : ''
					}
					<div className="entry-content cf">
						<hr />
						<SharePage />
						{content.byLine &&
							<div className="article-by-line">
								<p>{content.byLine}</p>
							</div>
						}
						<hr />
						{cpacItemList && cpacItemList.item && cpacItemList.item.length > 0 &&
							<>
								<div className="article-cpac-item-list">
									<ListItem items={cpacItemList} />
								</div>
								<hr />
							</>
						}
						<div className="article-content" itemProp="articleBody">
							<InnerHTML html={content.content} />
						</div>
						<hr />
						{cpacItemListBottom && cpacItemListBottom.item && cpacItemListBottom.item.length > 0 &&
							<div className="article-cpac-item-list">
								<ListItem items={cpacItemListBottom} />
							</div>
						}
					</div>

					{tags && tags.length > 0 &&
						<div className="article-tag-container">
							<hr />
							{renderTags()}
						</div>
					}
				</div>
			</ArticlePageHolder>
		</>
	)
}

const mapStateToProps = (store) => ({
	current_lang: store.language.current,
});

const mapDispatchToProps = (dispatch) => ({
	setCurrentLanguage: (lang) => dispatch({ type: 'SET_CUR_LANG', current: lang })
});

export default connect(mapStateToProps, mapDispatchToProps)(ArticlePage);